module.exports = __webpack_public_path__ + "img/word-recognition.4ee9133b.png";